import { defaultClient } from '@mint-sdk/api-core';
import type { z } from 'zod';

import {
  UpdateGroupingBodySchema,
  UpdateGroupingResponseSchema,
} from '../shared/schemas/groupings.js';
import {
  GroupingSchema,
  type GroupingTypeEnum,
} from '../shared/schemas/taxonomy.js';

export const updateGrouping = defaultClient.mutation({
  url: 'omni-trafficking/v1/groupings/$groupingId/' as const,
  method: 'PATCH',
  responseSchema: UpdateGroupingResponseSchema,
  requestSchema: UpdateGroupingBodySchema,
  processResponse(data) {
    return data.data;
  },
});

export type Grouping = z.infer<typeof GroupingSchema>;
export type UpdateGroupingBody = z.infer<typeof UpdateGroupingBodySchema>;
export type UpdateGroupingResponse = z.infer<
  typeof UpdateGroupingResponseSchema
>;
export type GroupingType = z.infer<typeof GroupingTypeEnum>;
